import { render } from "./Authenticate.vue?vue&type=template&id=4a6ce63a&scoped=true"
import script from "./Authenticate.vue?vue&type=script&lang=js"
export * from "./Authenticate.vue?vue&type=script&lang=js"

import "./Authenticate.vue?vue&type=style&index=0&id=4a6ce63a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c.turnbull.VT\\Documents\\GitHub\\vars-portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6ce63a"]])

export default __exports__